import { load } from "recaptcha-v3";

class Account {
	constructor() {
		// Create account
		var $div_different = $(".rf-customer-use-different-address");
		var $div_current = $(".rf-current-customer-container");

		// Recaptcha
		this.gcChallenge();

		$(document).on(
			"change",
			"#customer_register .rf-current-customer-radio input[type=radio]",
			function(e) {
				var $radio = $(this).val();

				$div_current.addClass("d-none");
				$div_current.find(".is-required").removeAttr("required");

				if ([0, 2].includes(parseInt($radio))) {
					$(
						'.rf-current-customer-container[data-state="false"]'
					).removeClass("d-none");
					$('.rf-current-customer-container[data-state="false"]')
						.find(".field-set-1 .is-required")
						.attr("required", "required");
				} else {
					$(
						'.rf-current-customer-container[data-state="true"]'
					).removeClass("d-none");
					$('.rf-current-customer-container[data-state="true"]')
						.find(".field-set-1 .is-required")
						.attr("required", "required");
				}
			}
		);

		$(document).on(
			"change",
			"#customer_register .rf-use-diffrent-address-radio input[type=radio]",
			function(e) {
				var $radio = $(this).val();

				$div_different.toggleClass("d-none");

				if ($div_different.hasClass("d-none")) {
					$div_different.find("input").removeAttr("required");
				} else {
					$div_different.find("input").attr("required", "required");
				}
			}
		);

		$(document).on(
			"click",
			".woocommerce-orders-table .add-to-cart.full",
			function() {
				var text = $('input[name="txt_should_bulk_add_to_cart"]').val();
				var order_id = $(this).data("order-id");

				if (confirm(text)) {
					window.location.href =
						ajax.cartUrl + "?bulk-add-from-order=" + order_id;
				}
			}
		);

		$(document).on(
			"click",
			".woocommerce-orders-table .add-to-cart.single",
			function() {
				var product_id = $(this)
					.closest("tr")
					.data("product-id");
				var variation_id = $(this)
					.closest("tr")
					.data("variation-id");
				var quantity = $(this)
					.closest("tr")
					.data("quant");

				var $submitBtn = $(this);

				var formData = {
					product_id: product_id,
					variation_id: variation_id,
					quantity: quantity,
					action: "wc_ajax_add_to_cart"
				};

				$submitBtn.css("pointer-events", "none").css("opacity", "0.7");
				$submitBtn.addClass("wc-button-loading");

				let $status = $submitBtn.parent().next();

				if ($status.hasClass("adc-status")) {
					$status.remove();
				}

				$.ajax({
					url: wc_add_to_cart_params.ajax_url,
					type: "POST",
					processData: true,
					data: formData,
					success: function(response) {
						if (response.fragments) {
							$(document.body).trigger("added_to_cart", [
								response.fragments,
								response.cart_hash,
								$submitBtn
							]);
							$("#site-content > .woocommerce").before(
								response.fragments.notices_html
							);
							$submitBtn
								.parent()
								.after(
									'<div class="adc-status fs-10 text-secondary">' +
										$(
											'input[name="txt_article_added"]'
										).val() +
										"</div>"
								);
						}
					},
					error: function(jqXHR, textStatus, errorThrown) {
						//console.log(jqXHR);
						//console.log(textStatus);
						//console.log(errorThrown);
						$submitBtn
							.parent()
							.after(
								'<div class="adc-status fs-10 text-frost-berry">' +
									$(
										'input[name="txt_error_adding_to_cart"]'
									).val() +
									"</div>"
							);
					},
					complete: function(data) {
						$submitBtn
							.css("pointer-events", "all")
							.css("opacity", "1");
						$submitBtn.removeClass("wc-button-loading");

						// Remove existing notices
						$(
							".woocommerce-error, .woocommerce-message, .woocommerce-info"
						).remove();
					}
				});

				return false;
			}
		);

		$(".woocommerce-orders-table .extended-order-data").on(
			"show.bs.collapse",
			function() {
				//const row_id = $(this).data('row');
				const order = $(this).data("order");
				const $resultsContainer = $(this).find(
					"> .single-order-details"
				);

				$resultsContainer.empty();

				$resultsContainer.LoadingOverlay("show", {
					imageClass: "jquery-loading-overlay-icon",
					image: ajax.templateUrl + "/assets/svg/loading.svg",
					imageResizeFactor: 1,
					text: $('input[name="txt_fetching_order"]').val(),
					textClass: "fs-16 py-3",
					textAutoResize: false,
					zIndex: 800,
					fade: 0,
					customAutoResize: false,
					imageAnimation: "1500ms pulse",
					background: "rgba(255, 255, 255, 0.8)"
				});

				let postVars = {
					action: "order_details_single",
					nonce: ajax.nonce,
					//row_id: row_id,
					order: order
				};

				$.ajax({
					beforeSend: xhr => {
						xhr.setRequestHeader("X-WP-Nonce", ajax.nonce);
					},
					url: ajax.url,
					method: "POST",
					data: postVars,
					dataType: "json"
				}).done(response => {
					var html = response.html
						? response.html
						: $('input[name="txt_error_fetching_order"]').val();
					$resultsContainer.LoadingOverlay("hide").html(html);
				});
			}
		);
	}

	async gcChallenge() {
		const recaptcha = await load(ajax.grecaptcha_site_key);
		const token = await recaptcha.execute("register_customer");
		const ginput = document.getElementById("gcaptchaChallengeToken");

		if (ginput && token) {
			ginput.value = token;
		}
	}
}

export default Account;
